import { render, staticRenderFns } from "./BlockUI.vue?vue&type=template&id=73813fc0&scoped=true&"
import script from "./BlockUI.vue?vue&type=script&lang=js&"
export * from "./BlockUI.vue?vue&type=script&lang=js&"
import style0 from "./BlockUI.vue?vue&type=style&index=0&id=73813fc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73813fc0",
  null
  
)

export default component.exports